import { ApiError } from "./fetch";
import { offsetToPosition } from "./util";
import yaml from "yaml";

export const schemaErrorToParseError = (
  err: ApiError & { body: { path: string[] } },
  pattern: string,
  doc: yaml.Document.Parsed
) => {
  const path = err.body.path;
  const node = path.reduce((a: any, c: number | string) => a.get(c, true), doc);
  return [
    {
      id: "invalid schema",
      message: err.body.error,
      start: offsetToPosition(pattern, node.range[0]),
      end: offsetToPosition(pattern, node.range[1]),
    },
  ];
};
